import * as React from 'react';
import styled, { keyframes } from 'styled-components';

type AnimationProps = {
  iterationCount?: number;
  duration?: string;
  easing?: string;
  fillMode?: string;
  delay?: string;
};

type Props = AnimationProps & {
  children: any;
};

const pulseKeyframe = keyframes`
  0% {
    transform: scale3d(1, 1, 1);
  }
  50% {
    transform: scale3d(1.15, 1.15, 1.15);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
`;

const Root = styled.div<AnimationProps>`
  animation-name: ${pulseKeyframe};
  animation-duration: ${({ duration }) => duration};
  animation-timing-function: ${({ easing }) => easing};
  animation-delay: ${({ delay }) => delay};
  animation-fill-mode: ${({ fillMode }) => fillMode};
  animation-iteration-count: ${({ iterationCount }) => iterationCount};
  height: 100%;
  width: 100%;
`;

const Pulse: React.FC<Props> = ({
  children,
  iterationCount = 1,
  duration = '0.7s',
  easing = 'ease-in',
  fillMode = 'both',
  delay = '1s',
}) => {
  return (
    <Root
      iterationCount={iterationCount}
      duration={duration}
      easing={easing}
      fillMode={fillMode}
      delay={delay}
    >
      {children}
    </Root>
  );
};

export default Pulse;
